export default "__VITE_ASSET__DxSQhl5y__"